if (typeof p80 === typeof undefined) {
	var p80 = {};
}

p80.bindHeaderSearch = function () {
	const searchToggles = document.querySelectorAll('[data-toggle-search]');
	const searchWrapper = document.querySelector('.header__search-wrapper');
	const searchForm = document.getElementById('header__search-form');
	const searchInput = document.getElementById('header__search-input');
	if (!searchToggles.length || !searchForm || !searchWrapper || !searchInput) return;
	const submitSearch = searchWrapper.querySelector('[data-submit-search]');
	let isOpen = false;
	if (window.innerWidth >= 990 && window.innerWidth < 1200) {
		isOpen = true;
	}
	for (var x = 0; x < searchToggles.length; x++) {
		searchToggles[x].addEventListener('keydown', function (e) {
			const key = e.key || e.keyCode;
			if (window.innerWidth < 990) {
				if (key === 13) {
					e.preventDefault();
					if (isOpen) {
						searchWrapper.classList.remove('visible');
						removeTrapFocus(searchForm);
					} else {
						searchWrapper.classList.add('visible');
						searchInput.focus();
						trapFocus(searchForm);
					}
					isOpen = !isOpen;
				}
			}
		});
		searchToggles[x].addEventListener('click', function (e) {
			e.preventDefault();
			if (window.innerWidth < 990) {
				if (isOpen) {
					searchWrapper.classList.remove('visible');
					removeTrapFocus(searchForm);
				} else {
					searchWrapper.classList.add('visible');
					// Wait for our animation to complete
					setTimeout(function () {
						searchInput.focus();
						trapFocus(searchForm);
					}, 150);
				}
			} else {
				if (isOpen) {
					searchWrapper.classList.remove('visible');
					removeTrapFocus(searchForm);
				} else {
					searchWrapper.classList.add('visible');
					// Wait for our animation to complete
					setTimeout(function () {
						searchInput.focus();
						trapFocus(searchForm);
					}, 150);
				}
			}
			isOpen = !isOpen;
		});
	}
	if (submitSearch) {
		submitSearch.addEventListener('click', function () {
			searchForm.submit();
		});
	}
	// Hide our search on outside clicks
	document.addEventListener('click', function (e) {
		if (
			!e.target.hasAttribute('data-toggle-search') &&
			!e.target.closest('[data-toggle-search]') &&
			e.target !== searchWrapper &&
			!searchWrapper.contains(e.target)
		) {
			searchWrapper.classList.remove('visible');
			isOpen = false;
		}
	});
};

window.addEventListener('DOMContentLoaded', (event) => {
	p80.bindHeaderSearch();
});
